<div #chargeList fxLayout="column" class="gap-4" *ngIf="firstReturn">
    <div class="records">
        <mat-form-field appearance="outline" fxFlex="17em">
            <input matInput (ngModelChange)="applyFilter1($event)" placeholder="Search" ngModel>
            <i class="flaticon-search" matSuffix></i>
        </mat-form-field>
        <div [matTooltip]="'Add tooltip text'">
            <button mat-raised-button class="addBtn clickIt" (click)="AddReexport()" *ngIf="!isCustomer">Add Re-Export
            </button>
        </div>
    </div>
    <div class="setTable">
        <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">
            <ng-container matColumnDef="container_number">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Container Number</mat-header-cell>
                <mat-cell *matCellDef="let element" class="m-card-sub-title" data-label="containerNumber">
                    {{ element?.requirement_container?.container_number ?? '-' }}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="size_type">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Size Type</mat-header-cell>
                <mat-cell *matCellDef="let element" class="m-card-sub-title" data-label="containerNumber">
                    {{ element?.requirement_container?.size ?? '-' }}{{ element?.requirement_container?.type ?? '-' }}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="carrier_name">
                <mat-header-cell *matHeaderCellDef mat-sort-header="carrier_name" sortActionDescription="Carrier Name">
                    Carrier Name
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="m-card-sub-title" data-label="CarrierName">
                    <app-text-field [isEditable]="element.isEdit" [(ngModel)]="element.carrier_name"
                                    [name]="'description'"
                                    class="" fxLayout="column">
                    </app-text-field>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="vessel_name">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Vessel Name</mat-header-cell>
                <mat-cell *matCellDef="let element" class="m-card-sub-title" data-label="vesselName">
                    <app-text-field [isEditable]="element.isEdit" [(ngModel)]="element.vessel_name"
                                    [name]="'description'"
                                    class="" fxLayout="column">
                    </app-text-field>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="voyage_number">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Voyage Number</mat-header-cell>
                <mat-cell *matCellDef="let element" class="m-card-sub-title" data-label="voyageNumber">
                    <app-text-field [isMultiline]="false" [isEditable]="element.isEdit"
                                    [(ngModel)]="element.voyage_number"
                                    [name]="'voyage_number'" class="" fxLayout="column">
                    </app-text-field>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="port_clearance_date">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    Port Clearence Date
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="m-card-sub-title" data-label="Port Clearence Date">
                    <app-date-field [isEditable]="element.isEdit"
                                    [(ngModel)]="element.port_clearance_date"></app-date-field>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="port_clearance_number">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    Port Clearence Number
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="m-card-sub-title" data-label="Port Clearence Number">
                    <app-text-field [isMultiline]="false" [isEditable]="element.isEdit"
                                    [(ngModel)]="element.port_clearance_number" [name]="'voyage_number'" class=""
                                    fxLayout="column">
                    </app-text-field>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="igm_number">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    IGM Number
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="m-card-sub-title" data-label="IGM Number">
                    <app-text-field [isMultiline]="false" [isEditable]="element.isEdit" [(ngModel)]="element.igm_number"
                                    [name]="'igm_number'" class="" fxLayout="column">
                    </app-text-field>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="igm_date">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    IGM Date
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="m-card-sub-title" data-label="IGM Date">
                    <app-date-field [isEditable]="element.isEdit" [(ngModel)]="element.igm_date"></app-date-field>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="remarks">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    Remarks
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="m-card-sub-title" data-label="remarks">
                    {{ element?.remarks ?? "-" }}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef> Actions</mat-header-cell>
                <mat-cell *matCellDef="let element; let i=index">
                    <!-- <div class="actions" (click)="deleteDOContainerPickup(element)">
                          <i class="flaticon-view"></i>
                      </div> -->
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="deleteReexportContainersList(element,i)">
                            <span>Delete</span>
                        </button>
                        <button mat-menu-item [disabled]="element.isEdit" (click)="edit(element)">
                            <span>Edit</span>
                        </button>
                        <button mat-menu-item [disabled]="!element.isEdit"
                                (click)="updateReexportContainersList(element,i)">Save
                        </button>
                    </mat-menu>
                </mat-cell>

            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
        <ng-container *ngIf="billuLoader && !dataSource?.data?.length ">
            <logzy-billu [part1]="part1 " [part2]="part2 " [part3]="part3" font="14px"></logzy-billu>
        </ng-container>
        <div class="loadingData" [class.d-none]="!update">
            <logzy-gear-loader></logzy-gear-loader>
        </div>
        <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page"
                       [length]="pageLength"
                       (page)="pageChanged($event)">
        </mat-paginator>
    </div>
</div>

<ng-container *ngIf="PickupContainer">
    <div class="t1 m-t-15 t1p">
    <span class="desc">
      Select the containers from the list
    </span>
    </div>
    <div class="inputs pl05em" fxLayout="row wrap" id="returnForm">
        <logzy-containers-list-for-reexport [containersList]="containersList" [containerDetails]="containerDetails"
                                            fxFlex="40%">
        </logzy-containers-list-for-reexport>

        <div class="inputs" fxLayout="row wrap" fxFlex="50%">
            <app-text-field [label]="'Vessel Name*'" [isMultiline]="false" [isEditable]="true" [(ngModel)]="vessel_name"
                            [name]="'vessel_name'" fxLayout="column" fxFlex="12em">
            </app-text-field>


            <app-text-field [label]="'Voyage Number*'" [isMultiline]="false" [isEditable]="true"
                            [(ngModel)]="voyage_number"
                            [name]="'voyage_number'" fxLayout="column" fxFlex="12em">
            </app-text-field>

            <app-date-field [label]="'Port Clearance Date*'" [isEditable]="true" [(ngModel)]="port_clearance_date"
                            fxLayout="column" fxFlex="14em" [errors]="errorObj.port_clearance_date"></app-date-field>


            <app-text-field [label]="'Port Clearance Number*'" [isMultiline]="false" [isEditable]="true"
                            [(ngModel)]="port_clearance_number"
                            fxFlex="12em"
                            [name]="'port_clearance_number'" class="" fxLayout="column">
            </app-text-field>


            <app-text-field [label]="'IGM Number*'" [isMultiline]="false" [isEditable]="true" [(ngModel)]="igm_number"
                            [name]="'igm_number'"
                            fxFlex="12em" fxLayout="column">
            </app-text-field>


            <app-date-field [label]="'IGM Date*'" [isEditable]="true" [(ngModel)]="igm_date"
                            [errors]="errorObj.igm_date"
                            fxLayout="column" fxFlex="14em"></app-date-field>


            <app-text-field [label]="'Carrier Name'" [isMultiline]="false" [isEditable]="true"
                            [(ngModel)]="carrier_name"
                            [name]="'carrier_name'"
                            fxFlex="12em" fxLayout="column">
            </app-text-field>

            <app-text-field [label]="'Remarks*'" [isMultiline]="true" [isEditable]="true" [(ngModel)]="remarks"
                            [name]="'remarks'"
                            class=""
                            fxFlex="12em" fxLayout="column">
            </app-text-field>
        </div>

        <div fxFlex="100" class="reviewBtn">
            <button mat-raised-button class="Cancel" (click)="backToList()"> Back To List
            </button>
            <button mat-raised-button class="Save" [disabled]="disableReturnButton"
                    (click)="postReexportContainersList()">
        <span *ngIf="!disableReturnButton">Save Reexport
          Details</span>
                <div *ngIf="disableReturnButton" class="p03">
                    <i class="flaticon-loading spin"></i>
                    <span>Saving...</span>
                </div>
            </button>
        </div>
    </div>
</ng-container>
